import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/models/apiResponse.model';
import { AddressData } from 'src/app/models/databank.model';
import { BaseApiService } from '../base/base-api.service';

/**
 * Databank Service - Handles third-party reference data lookups (e.g. PDOK address-data)
 */
@Injectable({ providedIn: 'root' })
export class DatabankService extends BaseApiService {
    private readonly addressDataPath = '/databank/v1/address-data/';

    constructor(http: HttpClient) {
        super(http);
    }

    /*-------------------------
    == ADDRESS DATA CALLS ==
    -------------------------*/

    getAddressData(countryCode: string, postalCode: string, houseNumber: string, houseNumberAddition?: string): Observable<ApiResponse<AddressData>> {
        return this.getAll<ApiResponse<AddressData>>(this.addressDataPath, {
            customParams: {
                countryCode,
                postalCode,
                houseNumber,
                ...(houseNumberAddition ? { houseNumberAddition } : {})
            }
        });
    }
}
